import { render } from "./TheProfessionalConsultationScrollItem.vue?vue&type=template&id=d50948d4&scoped=true&ts=true"
import script from "./TheProfessionalConsultationScrollItem.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalConsultationScrollItem.vue?vue&type=script&lang=ts"

import "./TheProfessionalConsultationScrollItem.vue?vue&type=style&index=0&id=d50948d4&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d50948d4"]])

export default __exports__